// assets
import { IconDashboard } from "@tabler/icons-react";

// constant
const icons = { IconDashboard };
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const subAdminDashboard = {
  id: "dashboard",
  title: "Dashboard",
  type: "item",
  url: "/portal/sub-admin/dashboard",
  icon: icons.IconDashboard,
};

export default subAdminDashboard;
